import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../../Context/ConfigContext";
import { NavLink } from "react-router-dom";
import { NoRecords } from '../../../Components/Shimmer';
import { currentDateAndTime, parseQueryString } from '../../../Constants/constants';


class WorkExperience extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      employee_work_experience_id: '',
      company_name: '',
      experience_period: '',
      last_CTC: '',
      designation: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSubmit: false,
      keyword: "",
      from_date: "",
      to_date: "",

      reference1: {
        name: '',
        contact: '',
        email: ''
      },
      reference2: {
        name: '',
        contact: '',
        email: ''
      },
      reference3: {
        name: '',
        contact: '',
        email: ''
      },
      errors: {} // Store validation errors
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const encryptedData = queryParams.get("data");
    if (encryptedData) {
    this.setState({ loadingList: true,
      loadingList:true,
          encryptedData:encryptedData,
          guest_employee_mobile_number: "",
          company_id: "",
     }, (prevState) => {
      this.getDecryptedData();
    });
  } else if (!encryptedData) {
    this.setState({
      encryptedData:'',
      guest_employee_mobile_number: "",
      company_id: "",
    });
  }
  }

  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleReferenceChange = (e, referenceName) => {
    const { name, value } = e.target;

    // Update the specific reference state
    this.setState((prevState) => ({
      [referenceName]: {
        ...prevState[referenceName],
        [name]: value
      }
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };


  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    const errors = this.validateForm();
    console.log(`Object.keys(errors).length`, Object.keys(errors).length);
    if (Object.keys(errors).length > 0) {
      // If there are validation errors, update the state with the errors
      this.setState({ errors });
      return;
    }
    this.setState({loadingSubmit:true});
    var formData = {
      employee_experience_detail:[{ 
        employee_work_experience_id: this.state.employee_work_experience_id || null,
        company_name: this.state.company_name,
        last_designation: this.state.designation,
        experience_period: this.state.experience_period,
        last_ctc: this.state.last_CTC,
        employee_work_experience_references: [
          this.state.reference1,
          this.state.reference2,
          this.state.reference3
        ]}],
    };

    axios.post(`${apiURL}Home/CreateUpdateEmployeeExperience`, formData, {
      params:{
        date: currentDateAndTime(),
        company_id: this.state.company_id,
        guest_employee_mobile_number: this.state.guest_employee_mobile_number,
      },
       headers }).then((response) => {
      const { success } = response.data;

      if (success === true) {
        this.setState({
          employee_work_experience_id: '',
          company_name: '',
          designation: '',
          experience_period: '',
          last_CTC: '',
          employee_work_experience_document_references: '',
          loadingSubmit:false,
        });
        this.closeRef.current.click();

        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      }

    }).catch((error)=>{
      console.log("Employees/CreateEmployeeWorkExperience ERROR:",error);
      Swal.fire({
        title: `<strong>Failed</strong>`,
        text: "Opps...! Something went wrong!",
        icon: 'error',
        showConfirmButton: true,
        allowOutsideClick:false
      })
    }).finally(this.setState({ loadingList: false, loadingSubmit:false }))
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Home/EmployeeCollectedData`, {
        params: {
          company_id: this.state.company_id,
            guest_employee_mobile_number:this.state.guest_employee_mobile_number,
            date: currentDateAndTime(),
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.employee_work_detail,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  getDecryptedData = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const fromData={
        encryptedData:this.state.encryptedData
    }
    axios
        .post(`${apiURL}User/DecryptData`,fromData, {headers})
        .then((response) => {
            var data = response.data;
            console.log('DecryptData',data);
            if (response.data.success === true) {
                let temp= parseQueryString(data?.decryptedData);
                console.log("tenp",temp);
                this.setState({
                  company_id:temp?.c_id,
                  guest_employee_mobile_number:temp?.mo_n,
                },()=>{
                  this.GetList();
                });
            } else {
              this.setState({
        
                loadingList: false,
              });
            }
        }).catch((error)=>{
          this.setState({
            loadingList: false,
          });
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Opps...! Something went wrong !!",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
            })
        });
};

  handleEdit=(row)=>{
    const reference= JSON.parse(row?.employee_work_experience_references);
    this.setState({
      employee_work_experience_id: row?.employee_work_experience_id,
      company_name: row?.company_name,
      designation: row?.last_designation,
      experience_period: row?.experience_period,
      last_CTC: row?.last_ctc,
      employee_work_experience_document_references: row?.employee_work_experience_document_references,
      reference1: {
        name: reference[0]?.name,
        contact: reference[0]?.contact,
        email: reference[0]?.email
      },
      reference2: {
        name: reference[1]?.name,
        contact: reference[1]?.contact,
        email: reference[1]?.email
      },
      reference3: {
        name: reference[2]?.name,
        contact: reference[2]?.contact,
        email: reference[2]?.email
      },
    })
  }

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to Delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_work_experience_id: id,
        };
        axios
          .post(`${apiURL}Home/DeleteExperienceDetails`, formData, {
            params:{
              company_id: this.state.company_id,
          guest_employee_mobile_number:this.state.guest_employee_mobile_number,
          date: currentDateAndTime(),
            },
             headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  validateForm = () => {
    const errors = {};
    const numberRegex = /^\d+(\.\d+)?$/;
    const mobileRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format

    if (!this.state.company_name) errors.company_name = 'Previous Company Name is required';
    if (!this.state.designation) errors.designation = 'Designation is required';
    if (!this.state.experience_period) errors.experience_period = 'Experience Period is required';
    if (this.state.experience_period && !numberRegex.test(this.state.experience_period)) errors.experience_period = 'Experience Period must be a number';
    if (!this.state.last_CTC) errors.last_CTC = 'Last CTC is required';
    if (!numberRegex.test(this.state.last_CTC)) errors.last_CTC = 'Last CTC must be a number';

    const references = ['reference1', 'reference2', 'reference3'];

    references.forEach((reference, index) => {
      const ref = this.state[reference];
      const refErrors = {};

      if (ref && (ref.name || ref.contact || ref.email)) {
        if (!ref.name) refErrors.name = `Reference ${index + 1} Name is required`;
        if (!ref.contact) {
          refErrors.contact = `Reference ${index + 1} Contact is required`;
        } else if (!mobileRegex.test(ref.contact)) {
          refErrors.contact = `Reference ${index + 1} Contact is invalid`;
        }
        if (!ref.email) {
          refErrors.email = `Reference ${index + 1} Email is required`;
        } else if (!emailRegex.test(ref.email)) {
          refErrors.email = `Reference ${index + 1} Email must be a valid email address`;
        }
      }

      if (Object.keys(refErrors).length > 0) {
        errors[reference] = refErrors;
      }
    });

    return errors;
  };




  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList(); // This will log the updated state value
      }
    );
  };
  render() {
    const { errors, loadingList } = this.state;

    return loadingList? (
      <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
          <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
              </div>
          </div>
      </div>
    ) :(

      <>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            <h5>Work Experience</h5>
          </div>
          <div>
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModalgrid">
              <i className="ri-menu-add-fill" style={{ fontSize: "16px" }} />
              Add
            </button>
            <div className="modal fade" id="exampleModalgrid" tabIndex={-1} aria-labelledby="exampleModalgridLabel" aria-modal="true">
              <div className="modal-dialog modal-xl">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalgridLabel">Work Experience</h5>
                    <button type="button" className="btn-close"
                    onClick={()=>{
                      this.setState({
                        employee_work_experience_id: '',
                        company_name: '',
                        designation: '',
                        experience_period: '',
                        last_CTC: '',
                        employee_work_experience_document_references: '',
                      })
                    }}     ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                  </div>
                  <div className="modal-body">
                    <div className="container mt-2">
                      <form onSubmit={this.handleSubmit}>
                        {/* First Column */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="company_name" className="form-label">Previous Company Name:<span
                              style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span></label>
                            <input
                              type="text"
                              id="company_name"
                              name="company_name"
                              value={this.state.company_name}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_name ? 'is-invalid' : ''}`}
                              placeholder="Enter Previous Company Name"
                            />
                            {errors.company_name && <div className="invalid-feedback">{errors.company_name}</div>}
                          </div>



                          <div className="col-md-6 mb-3">
                            <label htmlFor="designation" className="form-label">  Designation:<span
                              style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span></label>
                            <input
                              type="text"
                              id="designation"
                              name="designation"
                              value={this.state.designation}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.designation ? 'is-invalid' : ''}`}
                              placeholder="Enter Designation"
                            />
                            {errors.designation && <div className="invalid-feedback">{errors.designation}</div>}
                          </div>
                        </div>

                        {/* Second Column */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="experience_period" className="form-label">Experience Period:<span
                              style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span></label>
                            <input
                              type="number"
                              id="experience_period"
                              name="experience_period"
                              value={this.state.experience_period}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.experience_period ? 'is-invalid' : ''}`}
                              placeholder="Enter Experience In Years"
                            />
                            {errors.experience_period && <div className="invalid-feedback">{errors.experience_period}</div>}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label htmlFor="last_CTC" className="form-label">Last CTC:<span
                              style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span></label>
                            <input
                              type="number"
                              id="last_CTC"
                              name="last_CTC"
                              value={this.state.last_CTC}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.last_CTC ? 'is-invalid' : ''}`}
                              placeholder="Enter Your Last CTC"
                            />
                            {errors.last_CTC && <div className="invalid-feedback">{errors.last_CTC}</div>}
                          </div>

                        </div>


                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference1_name" className="form-label">Reference Name 1:</label>
                            <input
                              type="text"
                              id="reference1_name"
                              name="name"
                              value={this.state.reference1.name}
                              onChange={(e) => this.handleReferenceChange(e, 'reference1')}
                              className={`form-control ${errors.reference1 && errors.reference1.name ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Name 1"
                            />
                            {errors.reference1 && errors.reference1.name && <div className="invalid-feedback">{errors.reference1.name}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference1_contact" className="form-label">Reference Contact 1:</label>
                            <input
                              type="number"
                              id="reference1_contact"
                              name="contact"
                              value={this.state.reference1.contact}
                              onChange={(e) => this.handleReferenceChange(e, 'reference1')}
                              className={`form-control ${errors.reference1 && errors.reference1.contact ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Contact 1"
                            />
                            {errors.reference1 && errors.reference1.contact && <div className="invalid-feedback">{errors.reference1.contact}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference1_email" className="form-label">Reference Email 1:</label>
                            <input
                              type="email"
                              id="reference1_email"
                              name="email"
                              value={this.state.reference1.email}
                              onChange={(e) => this.handleReferenceChange(e, 'reference1')}
                              className={`form-control ${errors.reference1 && errors.reference1.email ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Email 1"
                            />
                            {errors.reference1 && errors.reference1.email && <div className="invalid-feedback">{errors.reference1.email}</div>}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference2_name" className="form-label">Reference Name 2:</label>
                            <input
                              type="text"
                              id="reference2_name"
                              name="name"
                              value={this.state.reference2.name}
                              onChange={(e) => this.handleReferenceChange(e, 'reference2')}
                              className={`form-control ${errors.reference2 && errors.reference2.name ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Name 2"
                            />
                            {errors.reference2 && errors.reference2.name && <div className="invalid-feedback">{errors.reference2.name}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference2_contact" className="form-label">Reference Contact 2:</label>
                            <input
                              type="number"
                              id="reference2_contact"
                              name="contact"
                              value={this.state.reference2.contact}
                              onChange={(e) => this.handleReferenceChange(e, 'reference2')}
                              className={`form-control ${errors.reference2 && errors.reference2.contact ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Contact 2"
                            />
                            {errors.reference2 && errors.reference2.contact && <div className="invalid-feedback">{errors.reference2.contact}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference2_email" className="form-label">Reference Email 2:</label>
                            <input
                              type="email"
                              id="reference2_email"
                              name="email"
                              value={this.state.reference2.email}
                              onChange={(e) => this.handleReferenceChange(e, 'reference2')}
                              className={`form-control ${errors.reference2 && errors.reference2.email ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Email 2"
                            />
                            {errors.reference2 && errors.reference2.email && <div className="invalid-feedback">{errors.reference2.email}</div>}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference3_name" className="form-label">Reference Name 3:</label>
                            <input
                              type="text"
                              id="reference3_name"
                              name="name"
                              value={this.state.reference3.name}
                              onChange={(e) => this.handleReferenceChange(e, 'reference3')}
                              className={`form-control ${errors.reference3 && errors.reference3.name ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Name 3"
                            />
                            {errors.reference3 && errors.reference3.name && <div className="invalid-feedback">{errors.reference3.name}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference3_contact" className="form-label">Reference Contact 3:</label>
                            <input
                              type="number"
                              id="reference3_contact"
                              name="contact"
                              value={this.state.reference3.contact}
                              onChange={(e) => this.handleReferenceChange(e, 'reference3')}
                              className={`form-control ${errors.reference3 && errors.reference3.contact ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Contact 3"
                            />
                            {errors.reference3 && errors.reference3.contact && <div className="invalid-feedback">{errors.reference3.contact}</div>}
                          </div>
                          <div className="col-md-4 mb-3">
                            <label htmlFor="reference3_email" className="form-label">Reference Email 3:</label>
                            <input
                              type="email"
                              id="reference3_email"
                              name="email"
                              value={this.state.reference3.email}
                              onChange={(e) => this.handleReferenceChange(e, 'reference3')}
                              className={`form-control ${errors.reference3 && errors.reference3.email ? 'is-invalid' : ''}`}
                              placeholder="Enter Reference Email 3"
                            />
                            {errors.reference3 && errors.reference3.email && <div className="invalid-feedback">{errors.reference3.email}</div>}
                          </div>
                        </div>

                        <div className="d-flex justify-content-end">
                        {!this.state.loadingSubmit?
                          <button type="submit" className={`btn btn-${this.state.employee_work_experience_id? "primary":"success"} btn-label waves-effect right waves-light`}>
                            <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> {this.state.employee_work_experience_id? "Update" :"Save"} </button>:
                            <button className={`btn btn-${this.state.employee_work_experience_id? "primary":"success"} btn-load`}>
                            <span className="d-flex align-items-center">
                                <span className="spinner-border flex-shrink-0" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </span>
                                <span className="flex-grow-1 ms-2">
                                {this.state.employee_work_experience_id? "Updating..." :"Saving..."}
                                </span>
                            </span>
                          </button>
  }
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th width={'190'} >Previous Company Name</th>
                <th width={'160'} >Previous Designation</th>
                <th width={'200'} >Work Experience</th>
                <th width={'150'} >Last CTC</th>
                <th width={'200'} >References</th>
                <th className="text-center">Action</th>

              </tr>
            </thead>
            {
              this.state.rows?.length === 0?
              <tbody>
                    <tr>
                        <td colSpan={9}>
                            <NoRecords/>
                        </td>
                    </tr>
                </tbody>:
                <tbody>
                {this.state.rows.map((row) => {
                  var references_obj = JSON.parse(row.employee_work_experience_references);
                  return (
                    <tr key={row.employee_work_experience_id}>
                      <td>{row.company_name}</td>
                      <td>{row.last_designation}</td>
                      <td>{row.experience_period}</td>
                      <td>{row.last_ctc}</td>
                      <td>
  
  
                        <div>
                          <ol style={{paddingLeft:"10px"}}>
                            {Object.entries(references_obj).map(([key, value], index) => (
                              <li key={index}>
                                {value.name !== '' && (
                                  <>
                                    <h6 style={{marginBottom:"0px"}}>{value.name}</h6>
                                    <br />
                                    <small>Contact: {value.contact}</small>
                                    <br />
                                    <small>Email: {value.email}</small>
                                    <hr />
                                  </>
                                )}
                              </li>
                            ))}
                          </ol>
                        </div>
  
                      </td>
                      <td >
                        <div className="d-flex justify-content-around gap-2">
                        <button
                           onClick={() =>
                            this.handleEdit(row)
                        }
                               data-bs-toggle="modal" data-bs-target="#exampleModalgrid"
                                className="btn-icon btn btn-sm btn-outline-primary">
                                <i className="ri-edit-box-line"></i>
                          </button>
                          <button
                            onClick={() =>
                              this.handleDelete(row.employee_work_experience_id)
                            }
                            className="btn-icon btn btn-sm btn-outline-danger"
                          >
                            <i className="ri-delete-bin-line"></i>{" "}
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            }

            {/* <tfoot className="table-light">
              <tr>
                <th colSpan={6}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot> */}
          </table>
        </div>
      </>
    );
  }
}

export default withRouter(WorkExperience);
